<!-- 特惠活动 -->
<template>
  <div class="">
    <!-- 导航头部组件 -->
    <HeaderNav chooseNav="1"></HeaderNav>
    <div class="img_box">
      <div class="pc_img"><img alt="" :src="item" style="max-width: 1880px;width: 100%;" v-for="(item, index) in pcImg" :key="index" /></div>
      <div class="wap_img"><img alt="" :src="wapImg" style="max-width: 1080px;width: 100%;" v-for="(item, index) in wapImg" :key="index" /></div>
      <!-- <vueMiniPlayer ref="vueMiniPlayer" :video="video" :mutex="true" @fullscreen="handleFullscreen" /> -->
    </div>
    <hr class="hr_1 mt0 mb30" />
    <!-- 脚步导航组件 -->
    <FooterNav></FooterNav>
  </div>
</template>

<script>
import HeaderNav from '../../components/HeaderNav';
import FooterNav from '../../components/FooterNav';
import RightNav from '../../components/RightNav.vue';
import { apiGetAdvert, apiGetList } from '../../api/activity.js';
export default {
  name: 'Index',
  components: {
    HeaderNav: HeaderNav,
    FooterNav: FooterNav,
    RightNav: RightNav
  },
  data() {
    return {
      pcImg: [],
      wapImg: [],
      video: {
        url: 'https://api.dogecloud.com/player/get.mp4?vcode=5ac682e6f8231991&userId=17&ext=.mp4',
        cover: 'https://i.loli.net/2019/06/06/5cf8c5d9c57b510947.png',
        muted: false,
        loop: false,
        preload: 'auto',
        poster: '',
        volume: 1,
        autoplay: false
      }
    };
  },
  created() {
    if (this.$route.query.id == 1) {
      this.pcImg = ['static/picture/FOLKTALE/detail/hl/sj (3).jpg', ''];
      this.wapImg =['static/picture/FOLKTALE/detail/hl/sj (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 2) {
      this.pcImg = ['static/picture/FOLKTALE/detail/hl/cm (3).jpg', ''];
      this.wapImg = ['static/picture/FOLKTALE/detail/hl/cm (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 3) {
      this.pcImg = ['static/picture/FOLKTALE/detail/hl/dhmrj (3).jpg', ''];
      this.wapImg = ['static/picture/FOLKTALE/detail/hl/dhmrj (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 4) {
      this.pcImg = ['static/picture/FOLKTALE/detail/hl/klshzm (3).jpg', ''];
      this.wapImg = ['static/picture/FOLKTALE/detail/hl/klshzm (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 5) {
      this.pcImg = ['static/picture/FOLKTALE/detail/hl/xhmrj (3).jpg', ''];
      this.wapImg = ['static/picture/FOLKTALE/detail/hl/xhmrj (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 6) {
      this.pcImg = ['static/picture/FOLKTALE/detail/hl/bxzmrj (3).jpg', ''];
      this.wapImg = ['static/picture/FOLKTALE/detail/hl/bxzmrj (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 7) {
      this.pcImg = ['static/picture/FOLKTALE/detail/hl/mmz (3).jpg', ''];
      this.wapImg =  ['static/picture/FOLKTALE/detail/hl/mmz (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 8) {
      this.pcImg = ['static/picture/FOLKTALE/detail/sh/hdxf (3).jpg', ''];
      this.wapImg = ['static/picture/FOLKTALE/detail/sh/hdxf (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 9) {
      this.pcImg = ['static/picture/FOLKTALE/detail/sh/qpq (3).jpg', ''];
      this.wapImg =  ['static/picture/FOLKTALE/detail/sh/qpq (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 10) {
      this.pcImg = ['static/picture/FOLKTALE/detail/sh/lcxf (3).jpg', ''];
      this.wapImg = ['static/picture/FOLKTALE/detail/sh/lcxf (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 11) {
      this.pcImg = ['static/picture/FOLKTALE/detail/sh/pgy (3).jpg', ''];
      this.wapImg =['static/picture/FOLKTALE/detail/sh/pgy (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 12) {
      this.pcImg = ['static/picture/FOLKTALE/detail/sh/xcl (3).jpg', ''];
      this.wapImg =  ['static/picture/FOLKTALE/detail/sh/xcl (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 13) {
      this.pcImg = ['static/picture/FOLKTALE/detail/sh/sfm (3).jpg', ''];
      this.wapImg =['static/picture/FOLKTALE/detail/sh/sfm (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 14) {
      this.pcImg = ['static/picture/FOLKTALE/detail/sh/sp (3).jpg', ''];
      this.wapImg = ['static/picture/FOLKTALE/detail/sh/sp (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 15) {
      this.pcImg = ['static/picture/FOLKTALE/detail/sh/stl (3).jpg', ''];
      this.wapImg = ['static/picture/FOLKTALE/detail/sh/stl (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 16) {
      this.pcImg = ['static/picture/FOLKTALE/detail/ssh/axk (3).jpg','',];
      this.wapImg = ['static/picture/FOLKTALE/detail/ssh/axk (3).jpg','',];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 17) {
      this.pcImg = ['static/picture/FOLKTALE/detail/ssh/ssmryywsj (3).jpg', ''];
      this.wapImg = ['static/picture/FOLKTALE/detail/ssh/ssmryywsj (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 18) {
      this.pcImg = ['static/picture/FOLKTALE/detail/ssh/ssmrrywsj (3).jpg', ''];
      this.wapImg = ['static/picture/FOLKTALE/detail/ssh/ssmrrywsj (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 19) {
      this.pcImg = ['static/picture/FOLKTALE/detail/ssh/ssmrhd (3).jpg', ''];
      this.wapImg = ['static/picture/FOLKTALE/detail/ssh/ssmrhd (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 20) {
      this.pcImg = ['static/picture/FOLKTALE/detail/ssh/ssmryy (3).jpg', ''];
      this.wapImg =['static/picture/FOLKTALE/detail/ssh/ssmryy (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 21) {
      this.pcImg = ['static/picture/FOLKTALE/detail/ssh/tcsxlry (3).jpg', ''];
      this.wapImg = ['static/picture/FOLKTALE/detail/ssh/tcsxlry (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 22) {
      this.pcImg = ['static/picture/FOLKTALE/detail/ssh/tcsxlyy (3).jpg', ''];
      this.wapImg =['static/picture/FOLKTALE/detail/ssh/tcsxlyy (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 23) {
      this.pcImg = ['static/picture/FOLKTALE/detail/xh/hd (3).jpg', ''];
      this.wapImg =  ['static/picture/FOLKTALE/detail/xh/hd (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 24) {
      this.pcImg = ['static/picture/FOLKTALE/detail/xh/hdxf (3).jpg', ''];
      this.wapImg =  ['static/picture/FOLKTALE/detail/xh/hdxf (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 25) {
      this.pcImg = ['static/picture/FOLKTALE/detail/xh/lcxx (3).jpg', ''];
      this.wapImg = ['static/picture/FOLKTALE/detail/xh/lcxx (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 26) {
      this.pcImg = ['static/picture/FOLKTALE/detail/xh/lcxf (3).jpg', ''];
      this.wapImg =['static/picture/FOLKTALE/detail/xh/lcxf (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 27) {
      this.pcImg = ['static/picture/FOLKTALE/detail/xh/pgyxx (3).jpg', ''];
      this.wapImg =['static/picture/FOLKTALE/detail/xh/pgyxx (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 28) {
      this.pcImg = ['static/picture/FOLKTALE/detail/xh/pgyxf (3).jpg', ''];
      this.wapImg = ['static/picture/FOLKTALE/detail/xh/pgyxf (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 29) {
      this.pcImg = ['static/picture/FOLKTALE/detail/xh/xmrdxx (3).jpg', ''];
      this.wapImg = ['static/picture/FOLKTALE/detail/xh/xmrdxx (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 30) {
      this.pcImg = ['static/picture/FOLKTALE/detail/xh/xmrdxf (3).jpg', ''];
      this.wapImg =['static/picture/FOLKTALE/detail/xh/xmrdxf (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 31) {
      this.pcImg = ['static/picture/FOLKTALE/detail/xh/ygxclxx (3).jpg', ''];
      this.wapImg =['static/picture/FOLKTALE/detail/xh/ygxclxx (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 32) {
      this.pcImg = ['static/picture/FOLKTALE/detail/xh/ygxclxf (3).jpg', ''];
      this.wapImg = ['static/picture/FOLKTALE/detail/xh/ygxclxf (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
    if (this.$route.query.id == 33) {
      this.pcImg = ['static/picture/FOLKTALE/detail/ssh/axt (3).jpg', ''];
      this.wapImg = ['static/picture/FOLKTALE/detail/ssh/axt (3).jpg', ''];
      this.video.url = '';
      this.video.cover = '';
    }
  },
  methods: {
    handleFullscreen() {},
    //立即报名
    submit(n) {
      if (this.login == true || this.login == 'true') {
        this.houseName = n;
        this.maskShow = true;
      } else {
        this.$message({ message: '请先登录', type: 'error' });
      }
    },

    //关闭通知弹窗
    closeSanTable() {
      this.maskShow = false;
    },

    //翻页
    handleCurrentChange(page) {
      console.log(page);
      this.page = page;
      this.getList();
    },

    //获取列表
    getList() {
      // this.$loading();
      const _this = this;
      var limit = this.pagesize;
      var page = this.page;
      apiGetList({
        limit: limit,
        page: page,
        nameAddress: ''
      })
        .then(res => {
          if (res.success) {
            this.list = res.data.list;
            this.total = Number(res.data.count);
          } else {
            this.$message({ message: res.msg, type: 'error' });
          }
          this.$loading().close();
        })
        .catch(err => {
          this.$message({ message: res.msg, type: 'error' });
          this.$loading().close();
        });
    },

    //判断是否登录
    judgeLogin() {
      if (sessionStorage.getItem('login') != null && sessionStorage.getItem('login') != '') {
        this.login = sessionStorage.getItem('login');
        if (sessionStorage.getItem('userInfo') != null && sessionStorage.getItem('userInfo') != '') {
          var userInfo = sessionStorage.getItem('userInfo');
          this.userInfo = JSON.parse(userInfo);
        }
      }
    },

    //获取广告内容
    getAdvert() {
      const _this = this;
      var limit = this.pagesize;
      var page = this.page;
      apiGetAdvert({})
        .then(res => {
          if (res.success) {
            this.advertInfo = res.data.advertInfo;
          } else {
            this.$message({ message: res.msg, type: 'error' });
          }
          this.$loading().close();
        })
        .catch(err => {
          this.$message({ message: res.msg, type: 'error' });
          this.$loading().close();
        });
    },

    //跳转页面    url:  页面地址  parame:  参数 key：参数值
    linkPage: function(url, id, key) {
      if (id == '') {
        this.$router.push({ path: url });
      } else {
        this.$router.push({ path: url, query: { id: key } });
      }
    },

    //跳转到详情页
    linkDetail(id) {
      this.$router.push({ path: '/messageDetail', query: { id: id } });
    },

    //跳转到外部链接
    linkOut(url) {
      if (url.includes('https://') || url.includes('http://')) {
        window.location.href = url;
      } else {
        window.location.href = `https://${url}`;
      }
    }
  }
};
</script>
<style scoped>
/* @media screen and (min-width: 0px) and (max-width: 768px) { */
@media (min-width: 768px){
  .nav li {
    padding: 0 15px;
  }
  .pc_img {
    display: none;
  }
  .wap_img {
    display: block;
  }
  .img_box .video_box .zhezhao img.img_pc {
    display: none;
  }
  .img_box .video_box .zhezhao img.img_wap {
    display: block;
  }
}

@media (min-width: 768px) {
  .pc_img {
    display: block;
  }
  .wap_img {
    display: none;
  }
  .img_box .video_box .zhezhao img.img_pc {
    display: block;
  }
  .img_box .video_box .zhezhao img.img_wap {
    display: none;
  }
}
/*------------brand.html  start----------------*/
.img_box {
  width: 100%;
  overflow: hidden;
  margin: 0 auto;
}
.img_box img {
  max-width: 100%;
  margin: 0 auto;
  display: block;
}
.img_box .video_box {
  width: 100%;
  margin: 0 auto;
  position: relative;
}
.img_box .video_box .zhezhao {
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0px;
  top: 0px;
  z-index: 555;
  overflow: hidden;
  cursor: pointer;
}
.img_box .video_box .zhezhao img {
  width: 100%;
  height: 100%;
  transition: all 1s ease-in-out;
}
.img_box .video_box .zhezhao img.img_pc {
  display: block;
}
.img_box .video_box .zhezhao img.img_wap {
  display: none;
}
.img_box .video_box video {
  width: 100%;
}
/*------------brand.html  end----------------*/
</style>



// WEBPACK FOOTER //
// src/view/Folktale/Detail.vue